import React from 'react';

/** Сворачиваемая секция с заголовком (блоки таблиц на страницах графиков). */
const ScheduleSectionPanel = ({
  title,
  subtitle,
  badge,
  expanded,
  onToggle,
  accent = '#5b7ea6',
  children,
  toolbar,
}) => (
  <section className={`glass-section${expanded ? ' glass-section--expanded' : ''}`}>
    <header
      role="button"
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle();
        }
      }}
      className="glass-section__header"
      style={{
        background: expanded
          ? `linear-gradient(90deg, ${accent}18 0%, transparent 60%)`
          : 'var(--glass-surface)',
        borderBottom: expanded ? '1px solid var(--glass-border-subtle)' : 'none',
      }}
    >
      <span
        aria-hidden
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 28,
          height: 28,
          borderRadius: 10,
          background: `${accent}22`,
          color: accent,
          fontWeight: 700,
          fontSize: 12,
          flexShrink: 0,
          transition: 'transform 0.2s ease',
          transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
        }}
      >
        ▶
      </span>
      <PanelTitle title={title} subtitle={subtitle} badge={badge} accent={accent} />
      <span
        className="glass-chip glass-chip--sm"
        style={{ color: accent, fontWeight: 600, flexShrink: 0 }}
      >
        {expanded ? 'Скрыть' : 'Показать'}
      </span>
    </header>
    {toolbar && expanded && <div className="glass-section__toolbar">{toolbar}</div>}
    {expanded && children}
  </section>
);

function PanelTitle({ title, subtitle, badge, accent }) {
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: 'var(--text-primary)' }}>
          {title}
        </h2>
        {badge != null && badge !== '' && (
          <span className="glass-chip glass-chip--sm" style={{ color: accent, fontWeight: 600 }}>
            {badge}
          </span>
        )}
      </div>
      {subtitle && (
        <p style={{ margin: '2px 0 0', fontSize: 12, color: 'var(--text-muted)' }}>{subtitle}</p>
      )}
    </div>
  );
}

export default ScheduleSectionPanel;
